//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'broadcastings',
    data() {
        var vm = this;
        return {
            searchInput: {},
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '标题',
                    key: 'title',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showDetail(row);
                                }
                            }
                        }, row.title));
                        return h('div', actions);
                    }
                },
                {
                    title: '状态',
                    key: 'statusStr',
                    align: 'center'
                },
                {
                    title: '创建时间', key: 'creationTimeStr', align: 'center'
                },
                {
                    title: '简介',
                    key: 'description',
                    align: 'center'
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delBroadcasting(params.row);
                                }
                            }
                        }, '删除');

                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.editBroadcasting(params.row);
                                }
                            }
                        }, '编辑');

                        var a = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.approve(params.row);
                                }
                            }
                        }, '审核');

                        var c = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.unApprove(params.row);
                                }
                            }
                        }, '取消审核');

                        if (row.status == 0) {

                            if (vm.hasPermission('Pages.Broadcasting.Audit')) {
                                actions.push(a);
                            }
                            if (vm.hasPermission('Pages.Broadcasting.Edit')) {
                                actions.push(edit);
                            }

                            if (vm.hasPermission('Pages.Broadcasting.Delete')) {
                                actions.push(del);
                            }
                        } else {
                            if (vm.hasPermission('Pages.Broadcasting.Audit')) {
                                actions.push(c);
                            }
                        }


                        return h('div', actions);
                    }

                }
            ],
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            list: [],
            saving: false,
            showEditBroadcastingModel: false,
            rules: {
                title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                description: [{ required: true, message: '请输入描述', trigger: 'blur' }],
                content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
                projectId: [{ required: true, type: 'number', message: '请选择项目', trigger: 'change' }]
            },
            broadcasting: {},
            broadcastingInfo: {},
            showBroadcastingModel: false,
            title: '',
            projects: []
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getPage();
        },
        getPage() {
            let page = {
                title: this.searchInput.title,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            this.loading = true;
            abp.ajax.post('/api/services/app/Broadcasting/Search', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        editBroadcasting(b) {
            this.broadcasting = {};
            this.$refs.broadcastingForm.resetFields();
            this.broadcasting = JSON.parse(JSON.stringify(b));
            if (this.broadcasting.id > 0) {
                this.title = '编辑';
            } else {
                this.title = '新增';
            }
            this.showEditBroadcastingModel = true;
        },
        onSave() {
            console.log(this.broadcasting);
            this.$refs.broadcastingForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Broadcasting/Save', this.broadcasting).then(() => {
                        this.loading = false;
                        this.showEditBroadcastingModel = false;
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        showDetail(row) {
            this.broadcastingInfo = row;
            this.showBroadcastingModel = true;
        },
        getProjects(cityId) {
            this.$store.dispatch({
                type: 'project/getProjects',
                data: { cityId: cityId }
            }).then(() => {
                this.projects = this.$store.state.project.projects;
            });
        },
        approve(row) {
            abp.ajax.post('/api/services/app/Broadcasting/Approve?id=' + row.id).then(() => {
                this.getPage();
            }).finally(() => {
                this.saving = false;
            });
        },
        unApprove(row) {
            abp.ajax.post('/api/services/app/Broadcasting/CancelApprove?id=' + row.id).then(() => {
                this.getPage();
            }).finally(() => {
                this.saving = false;
            });
        },
        delBroadcasting(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.title + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    abp.ajax.delete('/api/services/app/Broadcasting/Delete?id=' + row.id).then(() => {
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
        this.getProjects();
    }
};
